// ----------------------------------------------------------------------

const account = {
  displayName: '码中人(www.mzh.ren)',
  email: 'flowerszhong@hotmail.com',
  photoURL: '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
